import React from 'react';
import styles from './styles/TextWithIcon.module.scss';
import { Icon } from 'semantic-ui-react';

interface IProps {
  className?: string;
  text?: React.ReactNode;
}

export const ErrorText = ({ className, text }: IProps) => {
  return (
    <div className={classnames(styles.error, className)}>
      <Icon className={styles.errorIcon} name="exclamation circle" />
      {text}
    </div>
  );
};
